import { ReactNode } from 'react';
import { Trans } from '@lingui/react/macro';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export type ConfirmationVariant = 'default' | 'dangerous';

export interface ConfirmationDialogProps {
  title: ReactNode;
  description?: ReactNode;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  additionalActions?: ReactNode;
  variant?: ConfirmationVariant;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationDialog = ({
  title,
  description,
  confirmLabel,
  cancelLabel,
  additionalActions,
  variant = 'default',
  onConfirm,
  onCancel,
}: ConfirmationDialogProps) => {
  const isDangerous = variant === 'dangerous';

  return (
    <>
      <DialogTitle>{title}</DialogTitle>
      {description && (
        <DialogContent>
          <DialogContentText component="div" variant="body2" color="textPrimary">
            {description}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        {additionalActions}
        <Button onClick={onCancel}>{cancelLabel ?? <Trans>Cancel</Trans>}</Button>
        <Button
          onClick={onConfirm}
          color={isDangerous ? 'error' : 'primary'}
          variant="contained"
          autoFocus
        >
          {confirmLabel ?? <Trans>Confirm</Trans>}
        </Button>
      </DialogActions>
    </>
  );
};
